module.exports = __webpack_public_path__ + "static/vakif3-f81ec1536c5bb62e6cfee5095ca1085c.png";